// extracted by mini-css-extract-plugin
export default {"answer":"ModuleAssessmentResults_answer__3KbA8"};